import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/brukere',
    name: 'Brukere',
    component: () => import('./views/Brukere.vue')
  }
]

export default routes
